module.exports = "funciona"